import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../core/services/local-storage.service';
import { User } from '../../e-met/models/user';
import { DataService } from '../../e-met/services/data.service';
import { USER_ROLE } from '../../shared/shared.interface';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @ViewChild('navdrop') navdrop: ElementRef;

    userInfo$ = this.dataService.userInfo$;
    showUser$ = this.storage.token$;
    users = [999999999, 111111111, 222222222, 333333333, 444444444];
    selectedCitizen = '';

    constructor(
        public dataService: DataService,
        private router: Router,
        private storage: LocalStorageService
    ) {}

    ngOnInit(): void {
        this.selectedCitizen = this.storage.getMOCKTaxnumber();
    }

    showMore(user: any) {
        this.router.navigate([`/`], {
            replaceUrl: true,
        });
    }

    logout(user: any) {
        if (this.storage.getRole() === USER_ROLE.CITIZEN) {
            window.location.href = environment.citizenLogoutUrl;
        } else {
            window.location.href = environment.notaryLogoutUrl;
        }
    }

    isBlank(str) {
        return !str || /^\s*$/.test(str);
    }

    // onOptionsSelected(event) {
    //     console.log(this.selectedCitizen);
    //     this.storage.setUser(this.selectedCitizen);
    // }

    onChange(event) {
        console.log(event.target.value);
        this.storage.setMOCKTaxnumber(event.target.value);
    }
}
